import $http from "../../../axios";
import {MessageBox, Notification} from 'element-ui';
import moment from 'moment';

// Agregar items al carrito
export async function addCartItems({commit, state, dispatch, rootState}, products) {
    commit('setLockAdd', true);
    commit('setLockPromotions', true);
    commit('catalog/setAddingProduct', products, {root: true});
    
    let two_days_ago = new Date();
    two_days_ago.setDate(two_days_ago.getDate() - 2);
    if (rootState.catalog.date_of_fetch && rootState.catalog.date_of_fetch <= two_days_ago) {
        Notification.error({
            title: "¡Error!",
            message: 'Se recomienda listar el catalogo de nuevo',
            type: "error",
            duration: 5000,
            customClass: "notification-box"
        });
        commit('setLockAdd', false);
        commit('setLockPromotions', false);
        commit('catalog/quitAddingProduct', [], {root: true});  
        return;
    }

    products.model_id = state.selected_model.id;
    products.warehouse_id = rootState.login.user_b2b.id;
    products.branchoffice_id = rootState.login.user_b2b.branchoffice_id;
    products.return_document = 0;

    await $http.post('/api/items-carrito?is_client_portal=true', products).then(async () => {
        await dispatch('fetchCart', {
            contact_id: rootState.login.user_b2b.contact_id,
            branchoffice_id: rootState.login.user_b2b.id,
            user_id: rootState.login.user_logued.id
        });
    }).catch(error => {
        if (error.response && error.response.data && error.response.data.message){
            Notification.error({
                title: "¡Error!",
                message: error.response.data.message,
                type: "error",
                duration: 5000,
                customClass: "notification-box"
            });
        }
    });

    commit('setLockAdd', false);
    commit('setLockPromotions', false);
    commit('catalog/quitAddingProduct', [], {root: true});
}

// Eliminar items del carrito
export async function removeCartItems({ commit, dispatch, rootState }, item) {
    await $http.delete(`/api/items-carrito/${item.id}`).then(async response => {
        await commit("deleteItemCart", item);
        await dispatch("fetchCart", {
            contact_id: rootState.login.user_b2b.contact_id,
            branchoffice_id: rootState.login.user_b2b.id,
            user_id: rootState.login.user_logued.id
        });
    });
}

// Crear nuevo carrito
export async function newCart({ commit, state }, cart) {
    await $http
        .post("/api/carrito", cart)
        .then(response => {
            commit("setCart", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "¡Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}

// Obtener los datos del carrito
export async function fetchCart({ commit, state, dispatch }, parameters) {

    const is_cart_copy = localStorage.getItem('cart_copy');

	const params = {
		is_cart_copy
	}

    if (!state.cart.id || parameters.update_values) {
        params.update_values = true;
        params.observation = state.cart.observation;
        params.affects_prefix_document = state.cart.affects_prefix_document;
        params.affects_number_document = state.cart.affects_number_document;
        params.bulletin = state.cart.bulletin;
    }

    return await $http
        .get(
            `/api/carrito/${parameters.contact_id}/${parameters.branchoffice_id}/${parameters.user_id}`,
            { params }
        )
        .then(async response => {
            await commit("setCart", response.data.data);

            if (response && response.data && response.data.data && response.data.data.updates_values) {
                MessageBox.alert('Los Valores De Los Productos Del Carrito Han Sido Actualizados', 'Información', {
                    confirmButtonText: 'Aceptar',
                    type: 'warning'
                })

                return true;
            }
            return false;
        })
        .catch(error => {
            Notification.error({
                title: "¡Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
            return false;
        })
        .finally(() => {
            dispatch('fetchCartSuggested', parameters);
        });
}

/* Agregar items relacionados al carrito */
export async function addToCartFinalize(
    { rootState, dispatch },
    { id, cant, price, line_id, subline_id, brand_id, percentage_iva_sale }
) {
    let product = {
        document_id: rootState.cart.cart.id,
        product_id: id,
        seller: rootState.login.user_b2b.seller_id,
        line_id: line_id,
        subline_id: subline_id,
        brand_id: brand_id,
        applies_inventory: true,
        quantity: cant,
        unit_value_before_taxes: price.price,
        iva_percentage: percentage_iva_sale,
        discount_value: Math.round((price.price * price.percentage) / 100)
    };

    await dispatch("addCartItems", product);
}

/* Agregar información del carrito */
export async function addInformation({ commit, state }, information) {
    await $http
        .post("/api/informacion-carrito", information)
        .then(response => {
            commit("setInformation", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "¡Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}

/* Finalizar proceso de pedido */
export async function finalizeOrderAction({dispatch, rootState, commit, state}, cart) {
    // Validamos el monto mini por pedido
    let minimum_order_amount = rootState.login.user_b2b.branchoffice.minimum_order_amount;
    const is_cart_copy = localStorage.getItem('cart_copy');


    if (minimum_order_amount) {
        if (cart.total_value < minimum_order_amount) {
            commit('cartError', 'El valor total del pedido es inferior al monto mínimo.');

            return;
        }
    }

    let data = {
        id: cart.id,
        observation: cart.observation,
        affects_prefix_document: cart.affects_prefix_document,
        affects_number_document: cart.affects_number_document,
        bulletin: cart.bulletin,
        model_code: '010',
        is_cart_copy
    };

    let vouchertype_id = await dispatch('getVouchertype', {
        code: '001',
        branchoffice: rootState.login.user_b2b.branchoffice_id
    });

    await $http
        .post(`/api/finalizar-pedido`, data)
        .then(async response => {
            // Preparar datos obligatorios del carrito
            let cart = {
                warehouse_id: rootState.login.user_b2b.id,
                vouchertype_id: vouchertype_id,
                prefix: 'Pd',
                contact_id: rootState.login.user_b2b.contact_id,
                inventory_operation: 'pedido',
                in_progress: true,
                pay_condition: rootState.login.user_b2b.pay_condition,
                send_point: rootState.login.user_b2b.send_point,
                seller_id: rootState.login.user_b2b.seller_id,
                user_id: rootState.login.user_logued.id,
                documents_information: {
                    price_list: rootState.login.user_b2b.price_list_id
                }
            };
            // Crear carrito
            await dispatch('newCart', cart);
            //console.log(response.data);
            commit('setLastCart', response.data);
            commit('cartError', '');
        })
        .catch(error => {
            let data = error.response.data
            Notification.error({
                title: 'Error!',
                message: 'Error al finalizar el pedido',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
            if (data.dps_new_price) {
                commit(
                    'cartError',
                    `Estimado Cliente. <br> ${data.message}.`
                );
                commit('serDpNewPrice', data.dps_new_price);
            }else if(data.products_error){
                commit(
                    'cartError',
                    `Estimado Cliente. <br> ${data.message}.`
                );
            }else{
                let message = 'Estimado Cliente. <br> Estamos presentando algunos problemas de comunicación, por favor intentelo nuevamente.';
                console.log(data);
                if (data && data.message) {
                    message = `Estimado Cliente. <br> ${data.message}.`;
                }
                commit('cartError', message);
            }
        });
}

/**
 * Finalizar cotización
 */
export async function finalizeQuotation({dispatch, rootState, commit, state}, cart) {
    // Validamos el monto mínimo de la cotización
    let minimum_order_amount = rootState.login.user_b2b.branchoffice.minimum_order_amount;

    if (minimum_order_amount) {
        if (cart.total_value < minimum_order_amount) {
            commit('cartError', 'El valor total de la cotización es inferior al monto mínimo.');

            return;
        }
    }

    let data = {
        id: cart.id,
        observation: cart.observation,
        affects_prefix_document: cart.affects_prefix_document,
        affects_number_document: cart.affects_number_document,
        bulletin: cart.bulletin,
        model_code: '005'
    };

    let voucher_type_id = await dispatch('getVouchertype', {
        code: '001',
        branchoffice: rootState.login.user_b2b.branchoffice_id
    });

    await $http
        .post(`/api/finalizar-pedido`, data)
        .then(async response => {

            // Preparar datos obligatorios del carrito
            let cart = {
                warehouse_id: rootState.login.user_b2b.id,
                vouchertype_id: voucher_type_id,
                prefix: 'Pd',
                contact_id: rootState.login.user_b2b.contact_id,
                inventory_operation: 'pedido',
                in_progress: true,
                pay_condition: rootState.login.user_b2b.pay_condition,
                send_point: rootState.login.user_b2b.send_point,
                seller_id: rootState.login.user_b2b.seller_id,
                user_id: rootState.login.user_logued.id,
                documents_information: {
                    price_list: rootState.login.user_b2b.price_list_id
                }
            };

            // Crear cotización
            await dispatch('newCart', cart);
            commit('setLastCart', response.data);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: 'Error al finalizar el pedido',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });

            commit(
                'cartError',
                'Estimado Cliente. <br> Estamos presentando algunos problemas de comunicación, por favor inténtelo nuevamente.'
            );
        });
}

export async function getVouchertype({commit, state},voucherType){
    var params = {
        code_voucher_type:voucherType.code,
        branchoffice: voucherType.branchoffice
    }
    var voucherType_id
    await $http
        .get(`/api/tipo-comprobante`, {params})
        .then(response => {
            if (response.data) {
                voucherType_id = response.data.id
            }
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
    return voucherType_id
}

export async function getModelBycode({commit, state},code){
    await $http
        .get(`/api/modelo-por-codigo/${code}`)
        .then(response => {
            if (response.data.data) {
                commit("setSelectedModel", response.data.data);
            }
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}


export async function getPdf({ commit, state }, id) {
    await $http
        .get(`/api/imprimir-pedido/${id}`)
        .then(response => {
            commit("setPdf", response.data.data.pdf);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
}

export async function getCustomerCategoty({ commit, state }, contact_customer_id) {
    let contactCustomer = null
    await $http
        .get(`/api/categoria-cliente-prospecto/${contact_customer_id}`)
        .then(response => {
            contactCustomer = response.data.data
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("cartError", error.message);
        });
    return contactCustomer
}
export async function downloadDocument({ state }) {
    let name = state.pdf.split("/").pop();
    // let extension = name.split('.').pop()
    await $http({
        url: state.pdf,
        method: "GET",
        responseType: "blob" // important
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
}

/* Agregar items al carrito */
export async function addToCart({ rootState, dispatch, state }, product) {

    let user = JSON.parse(localStorage.getItem('user'));
    let user_b2b = JSON.parse(localStorage.getItem('user_b2b'));
    let subscriber = JSON.parse(localStorage.getItem('subscriber'));

    let discount_value = 0;

    if (!product.combo && subscriber.identification !== '800198348' && rootState.login.user_b2b.discount_percentage != null && product.price.price){
        discount_value = (product.price.price * parseFloat(rootState.login.user_b2b.discount_percentage)) / 100 * product.quantity;
    }

    let calculate_discount = !product.combo && subscriber.identification !== '800198348';

    let addProduct = {
        product_id: product.product_id ? product.product_id : product.id,
        seller_id: rootState.login.user_b2b.seller_id,
        contact_id: rootState.login.user_b2b.contact.id,
        quantity: product.quantity,
        original_quantity: product.quantity,
        model_id: state.selected_model.id,
        promotion_id: product.promotion_id,
        is_benefit: product.is_benefit ? product.is_benefit : false,
        discount_value: discount_value,
        document_product_id: product.document_product_id,
        calculate_discount: calculate_discount,
        unit_value_before_taxes: product.price
            ? product.price.price
            : undefined,
        unit_list_value: product.unit_list_value,
        discount_details: product.discount_details
    };

    let vouchertype_id = await dispatch("getVouchertype", {code:'001', branchoffice: rootState.login.user_b2b.branchoffice_id});

    // Validar si el carrito existe
    if (!state.cart.id) {
        // Preparar datos obligatorios del carrito
        let cart = {
            warehouse_id: rootState.login.user_b2b.id,
            vouchertype_id: vouchertype_id,
            prefix: "Pd",
            contact_id: rootState.login.user_b2b.contact_id,
            inventory_operation: "pedido",
            in_progress: true,
            model_id: state.selected_model.id,
            pay_condition: rootState.login.user_b2b.pay_condition,
            send_point: rootState.login.user_b2b.send_point,
            seller_id: rootState.login.user_b2b.seller_id,
            user_id: rootState.login.user_logued.id,
            documents_information: {
                price_list: rootState.login.user_b2b.price_list_id
            }
        };

        // Crear carrito
        await dispatch("newCart", cart);
    }

    // Asignar el id del carrito
    addProduct.document_id = rootState.cart.cart.id;
    // Agregar producto al carrito
    if (addProduct.quantity > 0) {
        await dispatch("addCartItems", addProduct);
    }
}

export async function checkCart({ rootState, dispatch, state }) {
    // Validar si el carrito existe
    let vouchertype_id = await dispatch("getVouchertype", {code:'001', branchoffice: rootState.login.user_b2b.branchoffice_id});

    if (!vouchertype_id) {
        Notification.error({
            title: "Error!",
            message: "No se encontró el tipo de comprobante 001 del pedido en la sede actual.",
            type: "error",
            duration: 5500,
            customClass: "notification-box"
        });
        return;
    }

    if (!state.cart.id) {
        // Preparar datos obligatorios del carrito
        let cart = {
            warehouse_id: rootState.login.user_b2b.id,
            vouchertype_id: vouchertype_id,
            prefix: "Pd",
            contact_id: rootState.login.user_b2b.contact_id,
            inventory_operation: "pedido",
            in_progress: true,
            pay_condition: rootState.login.user_b2b.pay_condition,
            send_point: rootState.login.user_b2b.send_point,
            seller_id: rootState.login.user_b2b.seller_id,
            user_id: rootState.login.user_logued.id,
            documents_information: {
                price_list: rootState.login.user_b2b.price_list_id
            }
        };

        // Crear carrito
        await dispatch("newCart", cart);
    }
}

/* Agregar productos de promoción al carrito */
//Obsoleto
export async function addPromotionToCart(
    { state, rootState, dispatch },
    product
) {
    let productAdd = {
        product_id: product.id,
        promotion_id: product.promotion,
        seller: rootState.login.user_b2b.seller_id,
        applies_inventory: false,
        quantity: product.quantity,
        unit_value_before_taxes: product.price.price,
        discount_value: Math.round((product.price.price * product.discount) / 100),
        original_quantity: product.quantity,
        line_id: product.line_id,
        brand_id: product.brand_id,
        subbrand_id: product.subbrand_id,
        subline_id: product.subline_id,
        category_id: product.category_id
    };
    let vouchertype_id = await dispatch("getVouchertype", {code:'001', branchoffice: rootState.login.user_b2b.branchoffice_id});

    // Validar si el carrito existe
    if (rootState.cart.cart.id == null || rootState.cart.cart.id == "") {
        // Preparar datos obligatorios del carrito
        let cart = {
            warehouse_id: rootState.login.user_b2b.id,
            vouchertype_id: vouchertype_id,
            prefix: "Pd",
            contact_id: rootState.login.user_b2b.contact_id,
            inventory_operation: "pedido",
            in_progress: true,
            pay_condition: rootState.login.user_b2b.pay_condition,
            send_point: rootState.login.user_b2b.send_point,
            seller_id: rootState.login.user_b2b.seller_id,
            user_id: rootState.login.user_logued.id,
            documents_information: {
                price_list: rootState.login.user_b2b.price_list_id
            }
        };

        // Crear carrito
        await dispatch("newCart", cart);

        // Obtener el id del carrito recién creado
        productAdd.document_id = rootState.cart.cart.id;

        // Agregar producto al carrito
        await dispatch("addCartItems", productAdd);
    } else {
        // Asignar el id del carrito
        productAdd.document_id = rootState.cart.cart.id;

        // Agregar producto al carrito
        await dispatch("addCartItems", productAdd);
    }
}

/** Aplicar descuento a la promoción cuando se cumple */
export async function applyBenefit(
    { state, commit, dispatch, rootState },
    promotion
) {
    // Agregar el beneficio al carrito o actualizar las unidades del beneficio
    if (promotion.comply && promotion.specific_product != null) {
        let product = {
            id: promotion.specific_product.id,
            quantity: promotion.specific_product.quantity,
            promotion_id: promotion.id,
            is_benefit: true
        };
        await dispatch("addToCart", product);
    }
}

/**
 * Obtiene el modelo de acuerdo al id del mismo
 * @param commit
 * @param state
 * @param requestParameters
 * @returns {Promise<void>}
 */
export async function fetchModel({ commit, state }, model_id) {
    await $http
        .get("/api/modelos/" + model_id)
        .then(response => {
            commit("setSelectedModel", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "¡Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

// Aplicar descuento 
export async function applyPercentageDiscount(
    { dispatch, rootState, commit },
    products
  ) {
    commit("setLockAdd", true);
    commit("setLockPromotions", true);
    commit("catalog/setAddingProduct", products, { root: true });
  
    await $http.post("/api/aplicar-descuento", { products: products, from_cart: true}).then(async response => {
      await dispatch("fetchCart", {
        contact_id: rootState.login.user_b2b.contact_id,
        branchoffice_id: rootState.login.user_b2b.id,
        user_id: rootState.login.user_logued.id
      });
    });
    commit("setLockAdd", false);
    commit("setLockPromotions", false);
  }
// ========================================================================
// Pedido Sugerido AI / Pedido Ideal
// ========================================================================

export async function loadProductsToSuggestedCartAi({commit, state, rootState, dispatch}) {

	if (!state.resume_ai.length) {
		return;
	}

    let vouchertype_id = await dispatch('getVouchertype', {
        code: '001',
        branchoffice: rootState.login.user_b2b.branchoffice_id
    });

	let cart = {
		warehouse_id: rootState.login.user_b2b.id,
		vouchertype_id: vouchertype_id,
		prefix: 'Pd',
		contact_id: rootState.login.user_b2b.contact_id,
		inventory_operation: 'pedido',
		in_progress: true,
		pay_condition: rootState.login.user_b2b.pay_condition,
		send_point: rootState.login.user_b2b.send_point,
		seller_id: rootState.login.user_b2b.seller_id,
		user_id: rootState.login.user_logued.id,
		documents_information: {
			price_list: rootState.login.user_b2b.price_list_id
		},
		is_suggested: true
	};

	// Crear carrito
	await dispatch('newCartSuggested', cart);

	let products = state.resume_ai.filter(p => p.status_code === 1);
	products = products.map(item => ({'id': item.id, 'order_quantity': item.order_quantity}))

	await $http.post(`/api/cargar-productos-carrito/${state.cart_suggested.id}`, {
		products,
		is_suggested: true
	})
		.then(async (response) => {

			commit('setCartSuggested', response.data.data);

			Notification.success({
				title: '¡Muy bien!',
				message: response.data.message,
				type: 'success',
				duration: 1500,
				customClass: 'notification-box'
			});

		}).catch((error) => {
			Notification.error({
				title: '¡Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box'
			});
			commit('cartError', error.message);
		}).finally(() => {
			commit('setLoadingImportExcel', false)
		});
}

export async function generateSuggestedOrderAi({ commit, state, rootState }, process_date) {
	const warehouse_id = rootState.login.user_b2b.id
	const contact_id = rootState.login.user_b2b.contact_id
	const branchoffice_id = localStorage.selected_branchoffice

	await $http.get(`/api/generate-suggested-order-ai`, {
		params: {
			contact_id,
			process_date,
			warehouse_id,
			branchoffice_id,
		}
	})
		.then((response) => {
			if (response.data.data.length) {
				commit('setResumeAi', response.data.data);
			} else {
				commit('setResumeAi', []);
				Notification.error({
					title: 'Aviso!',
					message: 'No cuenta con productos sugeridos.',
					type: 'error',
					duration: 1500,
					customClass: 'notification-box',
				});
			}
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

export async function generateSuggestedOrderAiByProductId({ commit, state, rootState }, product_id) {
	const warehouse_id = rootState.login.user_b2b.id
	const contact_id = rootState.login.user_b2b.contact_id
	const process_date = localStorage.process_date || moment().format('YYYY-MM-DD');

	await $http.get(`/api/generate-suggested-order-ai-by-product-id`, {
		params: {
			contact_id,
			process_date,
			warehouse_id,
			product_id
		}
	})
		.then((response) => {
			commit('setResumeProductAi', response.data.data);
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

export async function generateSuggestedQuantityOrderAiByProductId({ commit, state, rootState }, product_id) {
	const warehouse_id = rootState.login.user_b2b.id
	const contact_id = rootState.login.user_b2b.contact_id
	const process_date = localStorage.process_date || moment().format('YYYY-MM-DD');

	await $http.get(`/api/generate-suggested-quantity-order-ai-by-product-id`, {
		params: {
			contact_id,
			process_date,
			warehouse_id,
			product_id
		}
	})
		.then((response) => {
			commit('setResumeProductQuantityAi', response.data.data);
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

export async function getSuggestedProductPurchaseDaysQuantities({ commit, state, rootState }, product_id) {
	const warehouse_id = rootState.login.user_b2b.id
	const process_date = localStorage.process_date || moment().format('YYYY-MM-DD');

	await $http.get(`/api/suggested-product-purchase-days-quantities`, {
		params: {
			product_id,
			warehouse_id,
			process_date
		}
	})
		.then((response) => {
			commit('setSuggestedProductPurchaseDaysQuantities', response.data.data);
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

export async function getSuggestedProductSeasonality({ commit, state, rootState }, product_id) {
	const warehouse_id = rootState.login.user_b2b.id
	const process_date = localStorage.process_date || moment().format('YYYY-MM-DD');

	await $http.get(`/api/suggested-product-seasonality`, {
		params: {
			product_id,
			warehouse_id,
			process_date
		}
	})
		.then((response) => {
			commit('setSuggestedProductSeasonality', response.data.data);
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

export async function getSuggestedProductLastSale({ commit, state, rootState }, product_id) {
	const warehouse_id = rootState.login.user_b2b.id

	await $http.get(`/api/suggested-product-last-sale`, {
		params: {
			product_id,
			warehouse_id,
		}
	})
		.then((response) => {
			commit('setSuggestedProductLastSale', response.data.data);
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

export async function getSuggestedProductSalesCompany({ commit, state, rootState }, product_id) {
	const warehouse_id = rootState.login.user_b2b.id

	await $http.get(`/api/suggested-product-sales-company`, {
		params: {
			product_id,
			warehouse_id,
		}
	})
		.then((response) => {
			commit('getSuggestedProductSalesCompany', response.data.data);
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

export async function getSuggestedProductSalesResume({ commit, rootState }, product_id) {
	const warehouse_id = rootState.login.user_b2b.id;
	const contact_id = rootState.login.user_b2b.contact_id;
	const process_date = localStorage.process_date || moment().format('YYYY-MM-DD');

	await $http.get('/api/suggested-product-sales-resume', {
		params: {
			contact_id,
			warehouse_id,
			product_id,
			process_date,
		}
	})
		.then((response) => {
			const data = response.data.data || {};

			commit('setResumeProductAi', data.product_ai || []);
			commit('setResumeProductQuantityAi', data.product_ai_quantity || []);
			commit('setSuggestedProductPurchaseDaysQuantities', data.purchase_days_quantities || []);
			commit('setSuggestedProductSeasonality', data.seasonality || []);
			commit('setSuggestedProductLastSale', data.last_sale || []);
			commit('getSuggestedProductSalesCompany', data.sales_company || []);
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

export async function removeCartSuggestedItems({ commit, rootState }, document_id) {
	await $http.delete('/api/suggested-product-remove-items-cart', {
		params: {
			document_id
		}
	})
		.then((response) => {
		})
		.catch((error) => {
			Notification.error({
				title: 'Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box',
			});
		});
}

// Elimina todos los productos del carrito (sugeridos o no) -- usa el mismo
// endpoint de borrado individual que removeCartItems, en paralelo, y refresca
// el carrito una sola vez al final en lugar de un fetchCart por producto.
export async function clearCartItems({ dispatch, state, rootState }) {
	const items = state.cart.documents_products || [];

	await Promise.all(
		items.map(item => $http.delete(`/api/items-carrito/${item.id}`).catch(() => {}))
	);

	await dispatch('fetchCart', {
		contact_id: rootState.login.user_b2b.contact_id,
		branchoffice_id: rootState.login.user_b2b.id,
		user_id: rootState.login.user_logued.id
	});
}

export async function fetchCartSuggested({commit, state}, parameters) {
	const params = {
		...parameters,
		is_suggested: true
	}

	await $http.get(`/api/carrito/${parameters.contact_id}/${parameters.branchoffice_id}/${parameters.user_id}`, { params })
	.then((response) => {
        commit("setCartSuggested", response.data.data);
	}).catch((error) => {
		Notification.error({
			title: '¡Error!',
			message: error.message,
			type: 'error',
			duration: 1500,
			customClass: 'notification-box'
		});
		commit('cartError', error.message);
	});
}

// Crear nuevo carrito sugerido
export async function newCartSuggested({commit, state}, cart) {
	await $http.post('/api/carrito', {
		...cart,
		is_suggested: true
	})
	.then((response) => {
		commit('setCartSuggested', response.data.data);
	}).catch((error) => {
		Notification.error({
			title: '¡Error!',
			message: error.message,
			type: 'error',
			duration: 1500,
			customClass: 'notification-box'
		});
		commit('cartError', error.message);
	});
}

export async function updateItemDocument({ state, rootState }, product) {
	return await new Promise(async (resolve, reject) => {
		// Mismos datos de contexto que chengeProductCart()/addCartItems() usan
		// para el carrito real -- sin esto, createDocumentProduct() en el backend
		// no tiene con qué resolver precios/impuestos (model_id) y revienta.
		product.model_id = state.selected_model.id;
		product.warehouse_id = rootState.login.user_b2b.id;
		product.branchoffice_id = rootState.login.user_b2b.branchoffice_id;

		await $http.post('/api/items-carrito', product)
		.then(async (response) => {
			const data = (response.data && response.data.data && response.data.data.documents_products) || []
			const item = data.find(item => item.product_id === product.product_id )

			resolve(item);

		}).catch((error) => {
			Notification.error({
				title: '¡Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box'
			});
			reject(error);
		});
	});
}

export async function deleteItemDocument({}, id) {
	return await new Promise(async (resolve, reject) => {
		await $http.delete(`/api/items-carrito/${id}`)
		.then((response) => {
			Notification.success({
              title: "Exito!",
              message: "Producto eliminado correctamente",
              type: "success",
              duration: 1500,
              customClass: "notification-box",
            });
			resolve(response);
		})
		.catch((error) => {
			Notification.error({
				title: '¡Error!',
				message: error.response.data.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box'
			});
			reject(error);
		});
	});
}

export async function loadProductsToCartAi({commit, state, rootState, dispatch}) {

	if (!state.cartSuggestedProducts.length) {
		return;
	}

	if (!state.cart.id) {
		let cart = {
			warehouse_id: rootState.login.user_b2b.id,
			vouchertype_id: 1,
			prefix: 'Pd',
			contact_id: rootState.login.user_b2b.contact_id,
			inventory_operation: 'pedido',
			in_progress: true,
			pay_condition: rootState.login.user_b2b.pay_condition,
			send_point: rootState.login.user_b2b.send_point,
			seller_id: rootState.login.user_b2b.seller_id,
			user_id: rootState.login.user_logued.id,
			documents_information: {
				price_list: rootState.login.user_b2b.price_list_id
			}
		};

		// Crear carrito
		await dispatch('newCart', cart);
	}

	return await new Promise(async (resolve, reject) => {
		await $http.post(`/api/cargar-productos-carrito/${state.cart.id}`, {
			products: state.cartSuggestedProducts,
			is_suggested: true
		})
		.then(async (response) => {

			commit('setCart', response.data.data);

			Notification.success({
				title: '¡Muy bien!',
				message: response.data.message,
				type: 'success',
				duration: 1500,
				customClass: 'notification-box'
			});

			resolve(response)

		}).catch((error) => {
			Notification.error({
				title: '¡Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box'
			});
			commit('cartError', error.message);
			reject(error)
		}).finally(() => {
			commit('setLoadingImportExcel', false)
		});

	});
}

export async function fetchBrandSublineCategoryRelations({commit}, params) {
	commit('setBrandSublineCategoryRelations', []);
}

export async function loadProductsToSuggestedCartAiAsync({commit, state, rootState, dispatch}, products) {
	await $http.post(`/api/cargar-productos-carrito/${state.cart_suggested.id}`, {
		products,
		is_suggested: true,
		is_with_code: true,
		cleaning_products: true
	})
		.then(async (response) => {
			commit('setCartSuggested', response.data.data);
		}).catch((error) => {
			Notification.error({
				title: '¡Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box'
			});
		});
}

/**
 * Elimina un documento (carrito) por id. No formaba parte del paquete
 * pedido-sugerido-package (el propio README avisaba que había que portarla
 * si no existía ya en el destino) -- usa la ruta DELETE /api/carrito/{id}
 * que ya existe (DocumentAPIController@destroy, apiResource 'carrito').
 */
export async function deleteDocument({ commit }, document_id) {
	return await $http.delete(`/api/carrito/${document_id}`)
		.catch((error) => {
			Notification.error({
				title: '¡Error!',
				message: error.message,
				type: 'error',
				duration: 1500,
				customClass: 'notification-box'
			});
		});
}



// WEBPACK FOOTER //
// ./src/b2b/modules/cart/actions.js